import { create } from 'zustand';

interface SurveyState {
  // UI state
  isOpen: boolean;
  isMinimized: boolean;
  isDocked: boolean;
  hasBeenShown: boolean;
  
  // Survey progress
  currentStep: number;
  answers: Record<string, string>;
  
  // Results
  recommendation: any | null;
  
  // Actions
  openSurvey: () => void;
  closeSurvey: () => void;
  minimizeSurvey: () => void;
  expandFromBubble: () => void;
  dockBubble: () => void;
  undockBubble: () => void;
  setCurrentStep: (step: number) => void;
  setAnswer: (questionId: string, value: string) => void;
  setRecommendation: (rec: any) => void;
  resetSurvey: () => void;
  markAsShown: () => void;
}

export const useSurveyStore = create<SurveyState>((set) => ({
  // Initial UI state
  isOpen: false,
  isMinimized: true,
  isDocked: true,
  hasBeenShown: false,
  
  currentStep: 0,
  answers: {},
  recommendation: null,
  
  openSurvey: () => set({ isOpen: true, isMinimized: false }),
  closeSurvey: () => set({ isOpen: false, isMinimized: true }),
  minimizeSurvey: () => set({ isOpen: false, isMinimized: true }),
  expandFromBubble: () => set({ isOpen: true, isMinimized: false, isDocked: false }),
  dockBubble: () => set({ isMinimized: true, isDocked: true }),
  undockBubble: () => set({ isDocked: false }),
  
  setCurrentStep: (step) => set({ currentStep: step }),
  setAnswer: (questionId, value) => set((state) => ({
    answers: { ...state.answers, [questionId]: value }
  })),
  setRecommendation: (rec) => set({ recommendation: rec }),
  resetSurvey: () => set({
    currentStep: 0,
    answers: {},
    recommendation: null,
    isOpen: false,
    isMinimized: true,
    isDocked: false,
  }),
  markAsShown: () => set({ hasBeenShown: true }),
}));
